import axios from 'axios';
import config from '../config/config';

const DOMAIN = config.getBackendUrl;
const request = (method, url, data) => axios({ method, url: DOMAIN + url, data }).then(r => r.data);

export const mandoora_dashboard = {
  get_dashboard_data() { return request('post', '/api/mandoora/get_dashboard_data', {}); },
  get_daily_sales_statistics() { return request('post', '/api/mandoora/get_daily_sales_statistics', {}); },
};

export const mandoora_user = {
  get_userlist_recent({ count }) { return request('post', '/api/mandoora/get_userlist_recent', { count }); },
  get_userlist_have_gem({ count, type }) { return request('post', '/api/mandoora/get_userlist_have_gem', { count, type }); },
  get_search_user_list({ keyword }) { return request('post', '/api/mandoora/get_search_user_list', { keyword }); },
  get_user_info({ user_id }) { return request('post', '/api/mandoora/get_user_info', { user_id }); },
  ban_user({ user_id, exp, exp_info }) { return request('post', '/api/mandoora/ban_user', { user_id, exp, exp_info }); },
  unban_user({ user_id }) { return request('post', '/api/mandoora/unban_user', { user_id }); },
};

export const mandoora_mail = {
  create_mail({ mail_type, user_id, mail_info, expire_start, expire_end, admin_user }) { return request('post', '/api/mandoora/create_mail', { mail_type, user_id, mail_info, expire_start, expire_end, admin_user }); },
  edit_mail({ mail_no, mail_info, expire_start, expire_end, admin_user }) { return request('post', '/api/mandoora/edit_mail', { mail_no, mail_info, expire_start, expire_end, admin_user }); },
  get_mail_list_recent() { return request('post', '/api/mandoora/get_mail_list_recent', {}); },
  create_mail_multi({ user_list, mail_info, expire_start, expire_end, admin_user }) { return request('post', '/api/mandoora/create_mail_multi', { user_list, mail_info, expire_start, expire_end, admin_user }); },
};

export const mandoora_coupon = {
  create_coupon({ coupon_type, coupon_item, expire_dt, count, custom_coupon_id }) { return request('post', '/api/mandoora/create_coupon', { coupon_type, coupon_item, expire_dt, count, custom_coupon_id }); },
  get_recent_couponlist() { return request('post', '/api/mandoora/get_recent_couponlist', {}); },
  get_coupon_list({ coupon_pid }) { return request('post', '/api/mandoora/get_coupon_list', { coupon_pid }); },
};

export const mandoora_notice = {
  create_notice({ notice_title, notice_message, notice_type, is_enabled, admin_user }) { return request('post', '/api/mandoora/create_notice', { notice_title, notice_message, notice_type, is_enabled, admin_user }); },
  get_notice_list() { return request('post', '/api/mandoora/get_notice_list', {}); },
  get_notice({ id }) { return request('post', '/api/mandoora/get_notice', { id }); },
  set_notice({ id, notice_title, notice_message, is_enabled, notice_type }) { return request('post', '/api/mandoora/set_notice', { id, notice_title, notice_message, is_enabled, notice_type }); },
  delete_notice({ id }) { return request('post', '/api/mandoora/delete_notice', { id }); },
};

export const mandoora_product = {
  get_product_list() { return request('post', '/api/mandoora/get_product_list', {}); },
  create_product({ name, price, gem_amount, is_active }) { return request('post', '/api/mandoora/create_product', { name, price, gem_amount, is_active }); },
  edit_product({ pid, name, price, gem_amount, is_active }) { return request('post', '/api/mandoora/edit_product', { pid, name, price, gem_amount, is_active }); },
};

export const mandoora_cash_order = {
  get_cash_order_list({ count }) { return request('post', '/api/mandoora/get_cash_order_list', { count }); },
  search_cash_order_list({ user_id }) { return request('post', '/api/mandoora/search_cash_order_list', { user_id }); },
  edit_cash_order_state({ pid, process_state, comment }) { return request('post', '/api/mandoora/edit_cash_order_state', { pid, process_state, comment }); },
};

export const mandoora_user_buy_products = {
  get_user_buy_products({ count }) { return request('post', '/api/mandoora/get_user_buy_products', { count }); },
  search_user_buy_products({ user_id }) { return request('post', '/api/mandoora/search_user_buy_products', { user_id }); },
};

export const mandoora_event = {
  get_event_list() { return request('post', '/api/mandoora/get_event_list', {}); },
  create_event({ thumb_url, link_type, link_path, title, desc_text, button_text, priority, enable_yn }) { return request('post', '/api/mandoora/create_event', { thumb_url, link_type, link_path, title, desc_text, button_text, priority, enable_yn }); },
  edit_event({ pid, thumb_url, link_type, link_path, title, desc_text, button_text, priority, enable_yn }) { return request('post', '/api/mandoora/edit_event', { pid, thumb_url, link_type, link_path, title, desc_text, button_text, priority, enable_yn }); },
  delete_event({ pid }) { return request('post', '/api/mandoora/delete_event', { pid }); },
};

export const mandoora_setting = {
  get_setting() { return request('post', '/api/mandoora/get_setting', {}); },
  save_setting({ setting_data }) { return request('post', '/api/mandoora/save_setting', { setting_data }); },
  restart_server() { return request('post', '/api/mandoora/restart_server', {}); },
};
